import { createContext } from "react";
import type { Session, User } from "@supabase/supabase-js";

export const AUTH_UNAVAILABLE = "auth-unavailable";

export interface AuthContextValue {
	user: User | null;
	session: Session | null;
	loading: boolean;
	authAvailable: boolean;
	isSuperuser: boolean;
	signUp: (email: string, password: string) => Promise<{ error: string | null }>;
	signIn: (email: string, password: string) => Promise<{ error: string | null }>;
	signOut: () => Promise<void>;
}

export const UNAVAILABLE_AUTH_VALUE: AuthContextValue = {
	user: null,
	session: null,
	loading: false,
	authAvailable: false,
	isSuperuser: false,
	signUp: async () => ({ error: AUTH_UNAVAILABLE }),
	signIn: async () => ({ error: AUTH_UNAVAILABLE }),
	signOut: async () => undefined,
};

export const AuthContext = createContext<AuthContextValue | null>(null);
